import {
    FETCH_PRODUCT,
    FETCH_PRODUCTS,
    FETCH_PRODUCTS_ACCUMULATED,
    FETCH_PRODUCTS_FAILURE,
    FETCH_PRODUCTS_SUCCESS,
    FETCH_PRODUCT_ACCUMULATED,
    FETCH_PRODUCT_FAILURE,
    FETCH_PRODUCT_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchProducts = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_PRODUCTS,
        payload: params,
    };
};

export const fetchProductsFailure = (error) => {
    return {
        type: FETCH_PRODUCTS_FAILURE,
        error: error,
    };
};

export const fetchProductsSuccess = (payload) => {
    return {
        type: FETCH_PRODUCTS_SUCCESS,
        payload: payload,
    };
};

export const fetchProduct = (payload) => {
    return {
        type: FETCH_PRODUCT,
        payload: payload,
    };
};

export const fetchProductFailure = (error) => {
    return {
        type: FETCH_PRODUCT_FAILURE,
        error: error,
    };
};

export const fetchProductSuccess = (response) => {
    return {
        type: FETCH_PRODUCT_SUCCESS,
        response: response,
    };
};

export const fetchProductAccumulated = (payload) => {
    return {
        type: FETCH_PRODUCT_ACCUMULATED,
        payload: {
            id: payload.id,
            resource: 'products',
            type: FETCH_PRODUCTS_ACCUMULATED,
        },
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/fetchProducts.js